/**
 * Created by pzf on 18/9/1.
 *
 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Input } from 'mkui-fd';
import {
  buildOnSelectData,
  getFullHots,
  removeChoosed,
  addToChoosed,
  isChoosed,
  isSelected,
  removeChoosedOuter,
  getSearchResult,
} from './util';
import noop from '../_util/noop';

const { Search } = Input;

class Panel extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    data: PropTypes.array,
    hot: PropTypes.array,
    prefixCls: PropTypes.string,
    onSelect: PropTypes.func,
    multiple: PropTypes.bool,
    selected: PropTypes.array,
    searchPlaceholder: PropTypes.string,
  };

  static defaultProps = {
    data: [],
    hot: [],
    prefixCls: 'mkui-fee-type-panel',
    onSelect: noop,
    multiple: false,
    selected: [],
    searchPlaceholder: '请输入关键字搜索...',
  };

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = {
      choosed: [],
      searchResult: null,
      keywords: '',
    };
  }

  /** *******************handle************************** */
  /**
   * 选择费用类型选项后触发
   * @param item
   * @param e
   */
  selectHandle(item, e) {
    e.preventDefault();
    e.stopPropagation();
    this.choosed(item);
  }

  searchHandle = (e) => {
    const keywords = e.target.value;
    if (keywords) {
      this.search(keywords);
    } else {
      this.setState({
        searchResult: null,
        keywords: '',
      });
    }
  }

  selectSearchItemHandle = (item, e) => {
    this.setState({
      searchResult: null,
      keywords: '',
    });
    this.selectHandle(item, e);
  }

  /** *******************inner method************************** */
  search(keywords) {
    const { data } = this.props;
    const result = getSearchResult(data, keywords);
    this.setState({
      searchResult: result,
      keywords,
    });
  }

  /**
   * 选中费用类型选项
   * @param feeType
   */
  choosed(feeType) {
    const { multiple, data } = this.props;
    const { choosed } = this.state;
    const exsit = isChoosed(choosed, feeType);
    if (exsit) {
      // 取消选择
      if (multiple) {
        removeChoosed(data, choosed, feeType.feeTypeCode);
        this.setChoosedState(choosed);
        this.fireChange(choosed);
      }
    } else {
      if (multiple) {
        addToChoosed(choosed, feeType, multiple, data);
      } else {
        addToChoosed(choosed, feeType, multiple, data);
      }
      this.setChoosedState(choosed);
      this.fireChange(choosed);
    }
  }

  setChoosedState(choosed) {
    this.setState({ choosed });
  }

  fireChange(choosed) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(buildOnSelectData(choosed));
    }
  }

  /**
   *
   * @param item obj | array
   */
  removeChoosed(item) {
    const { data } = this.props;
    const { choosed } = this.state;
    removeChoosedOuter(data, choosed, item);
  }

  /** *******************render************************** */
  renderCategory() {
    const { props } = this;
    const { prefixCls } = props;
    const categories = props.data;
    if (categories && categories.length) {
      const categoriesEl = categories.map((category) => {
        return (
          <div className={classNames(`${prefixCls}-category`)}
               key={category.categoryCode}
          >
            <div className={classNames(`${prefixCls}-category-name`)}>{category.categoryName}</div>
            <div className={classNames(`${prefixCls}-category-children-wrapper`)}>
              {this.renderChildren(category)}
            </div>
          </div>
        );
      });
      return <div className={classNames(`${prefixCls}-category-wrapper`)}>{categoriesEl}</div>;
    }
    return '费用类型不存在！';
  }


  renderChildren(category) {
    const { prefixCls, selected } = this.props;
    if (category.children && category.children.length) {
      return category.children.map((feeType) => {
        return (
          <span key={`${category.categoryCode}-${feeType.feeTypeCode}`}
                className={classNames(`${prefixCls}-item`, { selected: isSelected(selected, feeType) })}
                onClick={(e) => {
                  this.selectHandle(feeType, e);
                }}
          >
            {feeType.feeTypeName}
          </span>
        );
      });
    }
  }


  renderHot() {
    const { prefixCls, hot, data } = this.props;
    if (hot && hot.length) {
      const fullHots = getFullHots(hot, data);
      const hostsEl = fullHots.map((item) => {
        return (
          <span key={`${item.categoryCode}-${item.feeTypeCode}`}
                className={classNames(`${prefixCls}-item`, { selected: item.selected })}
                onClick={(e) => {
                  this.selectHandle(item, e);
                }}
          >
            {item.feeTypeName}
          </span>
        );
      });
      return (
        <div className={classNames(`${prefixCls}-hot-wrapper`)}>
          <div className={classNames(`${prefixCls}-hot-title`)}>常用</div>
          <div className={classNames(`${prefixCls}-hot-content`)}>{hostsEl}</div>
        </div>
      );
    }
    return null;
  }

  renderContent() {
    const { prefixCls } = this.props;
    return (
      <div className={classNames(`${prefixCls}-wrapper`)}>
        {this.renderHot()}
        {this.renderCategory()}
      </div>
    );
  }

  renderSearchResult() {
    const { prefixCls } = this.props;
    const { searchResult, keywords } = this.state;
    return searchResult && searchResult.length > 0 ? (
      <ul className={`${prefixCls}-search-result`}>
        {searchResult.map((item) => (
          <li key={item.feeTypeCode} onClick={(e) => { this.selectSearchItemHandle(item, e); }}>
            {this.renderSearchResultItem(item.feeTypeName, keywords)}
          </li>
        ))}
      </ul>
    ) : (
      <div className={`${prefixCls}-search-empty`}>没有相关结果</div>
    );
  }

  renderSearchResultItem = (feeTypeName, keywords) => {
    const feeTypeNameArr = feeTypeName.split(keywords);
    return feeTypeNameArr.map((item, index) => {
      return index < feeTypeNameArr.length - 1 ? (
        <Fragment>
          {item}<strong>{keywords}</strong>
        </Fragment>
      ) : item;
    });
  }

  render() {
    const { prefixCls, searchPlaceholder } = this.props;
    const { searchResult, keywords } = this.state;
    return (
      <div className={classNames(`${prefixCls}`)}>
        <div className={`${prefixCls}-search`}>
          <Search
            value={keywords}
            className={`${prefixCls}-search-input`}
            placeholder={searchPlaceholder}
            onChange={this.searchHandle}
          />
        </div>
        {searchResult ? this.renderSearchResult() : this.renderContent()}
      </div>
    );
  }
}

export default Panel;
